/* eslint-disable react/prop-types */
/* eslint-disable react/destructuring-assignment */
import {useState} from 'react';
import './DeleteTag.scss';
import LoadingIndicator from './LoadingIndicator';
import Locale from '../util/Locale';
import Analytics from '../util/Analytics';

async function onDelete(props, setSpinner) {
    if (props.onDelete) {
        if (props.tag) {
            Analytics.trackEvent('Tag', `Delete from Delete Tag modal (${props.tag})`);
        }
        setSpinner(true);
        await props.onDelete();
        setSpinner(false);
    }
}

function renderFooter(props, isSpinning, setIsSpinning) {
    return (
        <div className="footerActions">
            <nsemble-button
                text
                onClick={() => {
                    props.setShowModal(false);
                }}
            >
                {Locale.getText('CANCEL')}
            </nsemble-button>
            <LoadingIndicator isLoading={isSpinning}>
                <nsemble-button
                    destructive-text
                    onClick={async () => {
                        if (props.onDelete) {
                            await onDelete(props, setIsSpinning);
                        }
                        props.setShowModal(false);
                    }}
                >
                    {Locale.getText('DELETE')}
                </nsemble-button>
            </LoadingIndicator>
        </div>
    );
}

export default function DeleteTag(props) {
    const [isSpinning, setIsSpinning] = useState(false);
    return (
        <div className="delete-tag-modal">
            <div id="modal-header">
                <h1>{Locale.getText('DELETE_TAG')}</h1>
            </div>
            {props.tag && <div className="delete-tag-message">&quot;{props.tag}&quot;</div>}
            {renderFooter(props, isSpinning, setIsSpinning)}
        </div>
    );
}
